<template>
  <div class="page-wx-code"></div>
</template>
<script>
import { getRequest } from 'utils/string';
import { WX_OPEN_ID_KEY } from '../../constants/pay';
export default {
  name: 'WXCode',
  // mounted() {
  //   setTimeout(() => {
  //     parent[WX_OPEN_ID_KEY] = '123';
  //   }, 3000);
  // }
  async mounted() {
    let query = getRequest();
    let code = query.code;
    let url = this.$route.params.url;
    let res = await this.$api.post.postPaymentWechatAuthorize({
      code
    });
    if (res.status === this.$code.SUCCESS && res.data) {
      let href = '';
      let openId = res.data.wechat_pay_openid;
      if (url.indexOf('?') > -1) {
        href = decodeURIComponent(url + '&openId=' + openId);
      } else {
        href = decodeURIComponent(url + '?openId=' + openId);
      }
      localStorage.setItem(WX_OPEN_ID_KEY, openId);
      window.location.href = href;
    }
  }
};
</script>
